export enum AreaState {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
